import listTemplate from './list/list.pug';
import formTemplate from './form/form.pug';
import viewTemplate from './view/view.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider
    .state('group.view.groupTransaction', {
    // /context/:ctxId/groups/:groupId/grouptransactions
    // :ctxId = ancestor/context group, :groupId = group
      url: '/grouptransactions',
      abstract: true,
      template: '<ui-view />'
    })
    .state('group.view.groupTransaction.list', {
      url: '',
      template: listTemplate,
      controller: 'GrpTransactionListCtrl',
      controllerAs: 'gtvm',
      authenticate: true
    })
    .state('group.view.groupTransaction.new', {
      url: '/new',
      template: formTemplate,
      controller: 'GrpTransactionFormCtrl',
      controllerAs: 'gtvm',
      authenticate: true
    })
    .state('group.view.groupTransaction.view', {
      url: '/:gtId',
      template: viewTemplate,
      controller: 'GrpTransactionViewCtrl',
      controllerAs: 'gtvm',
      authenticate: true
    })
    .state('group.view.groupTransaction.edit', {
      url: '/:gtId/edit',
      template: formTemplate,
      controller: 'GrpTransactionFormCtrl',
      controllerAs: 'gtvm',
      authenticate: true
    });
}];
